import AppText from "@common/component/AppText";
import AppSideModal from "@common/component/AppSideModal";
import { carDetailsToString } from "@common/helper";
import { Stack } from "@mui/material";
import moment from "moment";
import React from "react";
import { InventoryListingItem } from "../apiService";

interface DispatchInventoryDetailModalProps {
  open: boolean;
  data: InventoryListingItem;
  onClose?: () => void;
}

const DispatchInventoryDetailModal: React.FC<DispatchInventoryDetailModalProps> = ({ open, data, onClose }) => {
  const items = open
    ? [
        { label: "LEAD ID", value: data.lead.id },
        { label: "OUTBOUND STARTED ON", value: moment(data.lead.created_at).format("Do MMM 'YY, h:mm A") },
        { label: "CAR DETAILS", value: carDetailsToString(data.car_details) },
        { label: "HUB", value: "---" },
        { label: "KMS DRIVEN", value: "---" },
        { label: "FUEL TYPE", value: "---" },
        { label: "NO OF KEYS AVAILABLE", value: "---" },
      ]
    : [];

  return (
    <AppSideModal open={open} onClose={onClose} title="Dispatch">
      <Stack spacing="32px">
        {items.map((item) => (
          <Stack key={item.label} spacing="8px">
            <AppText fontSize={12} fontFamily="regular" color="#7D7D7D">
              {item.label}
            </AppText>
            <AppText fontSize={15} fontFamily="medium">
              {item.value}
            </AppText>
          </Stack>
        ))}
      </Stack>
    </AppSideModal>
  );
};

export default DispatchInventoryDetailModal;
